import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20cinematic%20background%20with%20subtle%20geometric%20shapes%20and%20flowing%20gradient%20lines%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20modern%20video%20platform%20aesthetic%2C%20soft%20light%20beams%20and%20bokeh%20effects%2C%20elegant%20and%20minimal%20design%2C%20no%20text%20or%20logos%2C%20cinematic%20atmosphere&width=1920&height=800&seq=hero-bg-01&orientation=landscape"
          alt="91视频网 - 海量高清视频在线观看平台"
          className="w-full h-full object-cover object-center"
          title="91视频网 - 海量高清视频在线观看平台"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          海量高清视频
          <span className="block text-primary-400">尽在91视频网</span>
        </h1>
        <p className="text-sm md:text-lg text-background-200/90 max-w-2xl mb-8 leading-relaxed">
          汇聚娱乐、教程、生活、音乐等多元内容，支持全高清流畅播放，为您打造极致在线视频观看体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/yule"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60"></div>
        </div>
      </div>
    </section>
  );
}